<span class="screen-darken"></span>
<header class="header" id="main-header">
    <div class="container">
        <div class="headTop">
            <a href="/" title="HOME" class="logo">
                <img src="./assets/img/purpleu.svg">
            </a>
            <div class="searchWrap">
                <input id="search-key" type="text" placeholder="검색어를 입력하세요." [(ngModel)]="key"
                                (keydown.enter)="handleOnSearch();">
                <a (click)="handleOnSearch();">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                </a>
            </div>
            <div class="d-none d-md-block userMenu">
                <div class="tgMyInfo" *ngIf="isLogined">
                    <h5>
                      <ng-container *ngIf="loginInfo?.grpCD === GRP_AREKHAN">
                        {{loginInfo?.userid}}, {{loginInfo?.regDate + '' | stringDate : 'kr':'-' }}, {{ loginInfo?.username }}님
                      </ng-container>
                      <ng-container *ngIf="loginInfo?.grpCD !== GRP_AREKHAN">
                        {{ loginInfo?.username }}님
                      </ng-container>
                        <ng-container *ngIf="smWownetPg.mpoint === 'Y'">
                            <a [routerLink]="'/my-office/point/point-inquiry'" style="margin-left: 15px;">
                                <span class="point">{{ memberPoint.havePoint ? memberPoint.havePoint : 0 | setComma }} <span>P</span></span>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg> -->
                            </a>
                        </ng-container>
                        <ng-container *ngIf="smWownetPg.mprepay === 'Y'">
                            <a [routerLink]="'/my-office/prepay/prepayment-details-inquiry'" style="margin-left: 15px !important;">
                                <span class="wpay">{{ totalPrepay | setComma }} <span>원</span></span>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg> -->
                            </a>
                        </ng-container>
                    </h5>
                </div>

                <ng-container *ngFor="let item of rightMenu;">
                    <ng-container *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                        <a href="javascript:;" (click)="handleOnClickRightMenu(item);">{{ item.prgName }}</a>
                    </ng-container>
                </ng-container>
                <ng-container *ngFor="let item of leftmenu">
                    <ng-container *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                        <ng-container *ngIf="item.prgId != 'ml.Shopping-mall'">
                            <ng-container *ngIf="item.prgId === 'ml.Register-clone-member' && loginInfo?.grpCD === GRP_AREKHAN">
                              <a (click)="onClickRegisterCloneMember(item)"
                                [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">{{ item.prgName }}</a>
                            </ng-container>
                            <ng-container *ngIf="item.prgId !== 'ml.Register-clone-member'">
                              <a [routerLink]="item.linkInfo"
                                [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">{{ item.prgName }}</a>
                            </ng-container>

                        </ng-container>
                        <ng-container *ngIf="item.prgId == 'ml.Shopping-mall'">
                            <a href="/" [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">{{ item.prgName }}</a>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <a data-trigger="navbar_main"  class="d-md-none openToggle">
                <span></span>
            </a>
        </div>
        <nav class="gnbWrap">
            <div class="allMenuOpen" (click)="handleCLickAllMenu();" [ngClass]="hadopen?'open':''">
                <span></span>
                <p>전체</p>
            </div>
            <div id="navbar_main" class="allMenu mobile-offcanvas">
                <div class="offcanvas-header">
                    <div class="tgTop">
                        <div class="userMenu">
                            <ng-container *ngFor="let item of rightMenu;">
                                <ng-container *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                                    <a href="javascript:;" (click)="handleOnClickRightMenu(item);">{{ item.prgName }}</a>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngFor="let item of leftmenu">
                                <ng-container *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                                    <ng-container *ngIf="item.prgId != 'ml.Shopping-mall'">
                                        <ng-container *ngIf="item.prgId === 'ml.Register-clone-member' && loginInfo?.grpCD === GRP_AREKHAN">
                                          <a (click)="onClickRegisterCloneMember(item)"
                                            [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">{{ item.prgName }}</a>
                                        </ng-container>
                                        <ng-container *ngIf="item.prgId !== 'ml.Register-clone-member'">
                                          <a [routerLink]="item.linkInfo"
                                            [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">{{ item.prgName }}</a>
                                        </ng-container>

                                    </ng-container>
                                    <ng-container *ngIf="item.prgId == 'ml.Shopping-mall'">
                                        <a href="javascript:;"
                                            (click)="handleOnclickShopping(item.linkInfo, '')"
                                            [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">{{ item.prgName }}</a>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                        <a class="btn-close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </a>
                    </div>
                    <div class="tgMyInfo" *ngIf="isLogined">
                      <ng-container *ngIf="loginInfo?.grpCD === GRP_AREKHAN">
                        <h2>{{loginInfo?.userid}}, {{loginInfo?.regDate + '' | stringDate : 'kr':'-' }}, {{ loginInfo?.username }}님 안녕하세요.</h2>
                      </ng-container>
                      <ng-container *ngIf="loginInfo?.grpCD !== GRP_AREKHAN">
                        <h2>{{ loginInfo?.username }}님 안녕하세요.</h2>
                      </ng-container>
                        <div class="row">
                            <div class="col-6">
                                <a [routerLink]="'/my-office/point/point-inquiry'">
                                    포인트
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                                </a>
                                <div class="point">
                                    {{ memberPoint.havePoint ? memberPoint.havePoint : 0 | setComma }}<span>P</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <a [routerLink]="'/my-office/prepay/prepayment-details-inquiry'">
                                    W 페이
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                                </a>
                                <div class="wpay">
                                    {{ totalPrepay | setComma }} <span>원</span>
                                </div>
                            </div>
                            <!-- <div class="col-4">
                                <a href="#none">
                                    쿠폰
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                                </a>
                                <div>1 개</div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngIf="activeTopLeft != 'ml.My-office' && activeTopLeft != 'ml.Home'">
                        <ng-container *ngFor="let item of pdtCates;">
                            <ng-container *ngIf="item.lv == '1' && item.cateNameOrg == 'GENERAL'">
                                <div class="col-auto">
                                    <h3 class="depth1">
                                        <a (click)="handleOnclickShopping('/', item)">
                                            {{ item.cateName }}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
                                        </a>
                                    </h3>
                                    <div class="depth2">
                                        <ng-container *ngFor="let item2 of pdtCates;">
                                            <ng-container *ngIf="item2.lv == '2' && item2.pCd == item.cateCd">
                                                <a (click)="handleOnclickShopping('/', item2)">{{ item2.cateName }}</a>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="activeTopLeft == 'ml.My-office'">
                        <ng-container *ngFor="let item of mainItems;">
                            <ng-container
                            *ngIf="(item.data.loginYn == 'A'
                            || (isLogined
                               && (item.data.loginYn == 'Y'
                                 || item.data.loginYn == loginInfo?.userid
                                 || item.data.loginYn == loginInfo?.isGrpDirect
                                 || item.data.loginYn == loginInfo?.isCenterDirect
                                 || (item.data.loginYn == 'M' && loginInfo?.userKindCd != 'U00')
                                 || (item.data.loginYn == 'S' && loginInfo?.userKindCd == 'U00')))
                            || (!isLogined && item.data.loginYn == 'N'))
                            &&item.data.menuYn == 'Y'">
                                <div class="col-auto">
                                    <h3 class="depth1">
                                        <a (click)="handleOnclickMyoffice(item.data.linkInfo);">
                                            {{ item.data.prgName }}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
                                        </a>
                                    </h3>
                                    <div class="depth2">
                                        <ng-container *ngFor="let item2 of item.children;">
                                            <ng-container *ngIf="(item2.data.loginYn == 'A'
                                            || (isLogined
                                               && (item2.data.loginYn == 'Y'
                                                 || item2.data.loginYn == loginInfo?.userid
                                                 || item2.data.loginYn == loginInfo?.isGrpDirect
                                                 || item2.data.loginYn == loginInfo?.isCenterDirect
                                                 || (item2.data.loginYn == 'M' && loginInfo?.userKindCd != 'U00')
                                                 || (item2.data.loginYn == 'S' && loginInfo?.userKindCd == 'U00')))
                                            || (!isLogined && item2.data.loginYn == 'N'))
                                            &&item2.data.menuYn == 'Y'">
                                                <a (click)="handleOnclickMyoffice(item2.data.linkInfo);">{{ item2.data.prgName }}</a>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="activeTopLeft == 'ml.Home'">
                        <ng-container *ngFor="let item of mainItems;">
                            <ng-container
                            *ngIf="(item.data.loginYn == 'A'
                            || (isLogined
                               && (item.data.loginYn == 'Y'
                                 || item.data.loginYn == loginInfo?.userid
                                 || item.data.loginYn == loginInfo?.isGrpDirect
                                 || item.data.loginYn == loginInfo?.isCenterDirect
                                 || (item.data.loginYn == 'M' && loginInfo?.userKindCd != 'U00')
                                 || (item.data.loginYn == 'S' && loginInfo?.userKindCd == 'U00')))
                            || (!isLogined && item.data.loginYn == 'N'))
                            &&item.data.menuYn == 'Y'">
                                <div class="col-auto">
                                    <h3 class="depth1">
                                        <a (click)="handleOnclickMyoffice(item.data.linkInfo);">
                                            {{ item.data.prgName }}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
                                        </a>
                                    </h3>
                                    <div class="depth2">
                                        <ng-container *ngFor="let item2 of item.children;">
                                            <ng-container *ngIf="(item2.data.loginYn == 'A'
                                            || (isLogined
                                               && (item2.data.loginYn == 'Y'
                                                 || item2.data.loginYn == loginInfo?.userid
                                                 || item2.data.loginYn == loginInfo?.isGrpDirect
                                                 || item2.data.loginYn == loginInfo?.isCenterDirect
                                                 || (item2.data.loginYn == 'M' && loginInfo?.userKindCd != 'U00')
                                                 || (item2.data.loginYn == 'S' && loginInfo?.userKindCd == 'U00')))
                                            || (!isLogined && item2.data.loginYn == 'N'))
                                            &&item2.data.menuYn == 'Y'">
                                                <a (click)="handleOnclickMyoffice(item2.data.linkInfo);">{{ item2.data.prgName }}</a>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="snbSwiper swiperRight">
                <div class="swiper-wrapper">
                    <ng-container *ngFor="let item of mainItems;">
                        <ng-container
                        *ngIf="(item.data.loginYn == 'A'
                        || (isLogined
                           && (item.data.loginYn == 'Y'
                             || item.data.loginYn == loginInfo?.userid
                             || item.data.loginYn == loginInfo?.isGrpDirect
                             || item.data.loginYn == loginInfo?.isCenterDirect
                             || (item.data.loginYn == 'M' && loginInfo?.userKindCd != 'U00')
                             || (item.data.loginYn == 'S' && loginInfo?.userKindCd == 'U00')))
                        || (!isLogined && item.data.loginYn == 'N'))
                        &&item.data.menuYn == 'Y'">
                            <ng-container *ngIf="(item.data.prgId === 'ml.Office.Auto-ship' || item.data.linkInfo === 'Subscription') && (loginInfo?.grpCD == GRP_AREKHAN || loginInfo?.grpCD == GRP_01)">
                                <div class="swiper-slide" [attr.data-program-id]="item.data.prgId">
                                    <ng-container *ngIf="item.data.prgKind === 'mo'">
                                        <ng-container *ngIf="item.data.prgId === 'ml.Office.Auto-ship' && (loginInfo?.grpCD == GRP_AREKHAN || loginInfo?.grpCD == GRP_01)">
                                            <a [routerLink]="item.data.linkInfo" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                        </ng-container>
                                        <ng-container *ngIf="item.data.prgId !== 'ml.Office.Auto-ship'">
                                            <a [routerLink]="item.data.linkInfo" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="item.data.prgKind === 'ms'">
                                        <ng-container *ngIf="item.data.linkInfo === 'Subscription' && (loginInfo?.grpCD == GRP_AREKHAN || loginInfo?.grpCD == GRP_01)">
                                            <a (click)="handleOnclickShopping(item.data.linkInfo, '')" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                        </ng-container>
                                        <ng-container *ngIf="item.data.linkInfo !== 'Subscription'">
                                            <a (click)="handleOnclickShopping(item.data.linkInfo, '')" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="item.data.prgKind === 'mh'">
                                        <a [routerLink]="item.data.linkInfo" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="(item.data.prgId !== 'ml.Office.Auto-ship' && item.data.linkInfo !== 'Subscription')">
                              <div class="swiper-slide" [attr.data-program-id]="item.data.prgId">
                                  <ng-container *ngIf="item.data.prgKind === 'mo'">
                                      <a [routerLink]="item.data.linkInfo" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                  </ng-container>
                                  <ng-container *ngIf="item.data.prgKind === 'ms'">
                                      <a (click)="handleOnclickShopping(item.data.linkInfo, '')" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                  </ng-container>
                                  <ng-container *ngIf="item.data.prgKind === 'mh'">
                                      <a [routerLink]="item.data.linkInfo" [ngClass]="activeId === item.data.prgId ? 'active' : ''">{{ item.data.prgName }}</a>
                                  </ng-container>
                              </div>
                          </ng-container>

                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </nav>
    </div>
</header>
<board-popup></board-popup>
<section class="popups-member-container">
    <list-cart
      [urlWownet]="urlWownet"
      [show]="showCartPopup"
      (clickClosePopup)="handleOnClickToggleCartPopup($event);">
    </list-cart>
</section>
<app-autologout style="display: none;"></app-autologout>
<ngx-loading [show]="loading"></ngx-loading>
